<template>
  <div class="recharge_wrap invest-page">
    <div class="red_top_bg page-top">
      <div
        class="back_left"
        @click="$router.go(-1)"
      />
      <div class="big_tit">
        {{ $t('invest.recharge') }}
      </div>
      <button
        type="button"
        class="top_right"
        @click="$router.push('/rechargeRecord')"
      >
        <van-icon
          name="bars"
          size="22"
        />
      </button>
    </div>

    <section
      v-if="eye == 1"
      class="balance-card"
    >
      <p>{{ $t('sky.jifen') }}</p>
      <strong>{{ balance }}</strong>
      <span>{{ $t('invest.availableBalance') }}</span>
    </section>
    <section
      v-if="eye == 0"
      class="balance-card"
    >
      <strong>******</strong>
      <span>
        {{ $t('invest.availableBalance') }}
        <van-icon
          name="closed-eye"
          @click="eye = 1"
        />
      </span>
    </section>

    <form class="form">
      <section class="amount-card">
        <p class="card-title">
          {{ $t('invest.rechargeAmount') }}
        </p>
        <div class="amount-field">
          <input
            v-model.trim="data.money"
            type="number"
            min="1"
            step="1"
            class="inp"
            :placeholder="$t('invest.rechargeAmount')"
            @input="changeAmount"
          >
          <span class="amount-mark">{{ payment.mark }}</span>
        </div>
        <p
          v-if="actualAmount"
          class="amount-preview"
        >
          {{ actualAmount }}
        </p>
      </section>

      <section class="payment-card">
        <div class="tit">
          {{ $t('invest.paymentMethod') }}
        </div>
        <div
          v-for="(v, k) in paymentList"
          :key="v.id || k"
          class="item"
          :class="{ active: k + 1 == data.choose }"
          @click="choose_type(k + 1, v)"
        >
          <div
            class="check"
            :class="k + 1 == data.choose ? 'checked' : ''"
          />
          <div class="re_icon">
            <img
              :src="v.logo"
              alt=""
            >
          </div>
          <div class="re_name">
            {{ v.name }}
          </div>
        </div>
      </section>

      <button
        type="button"
        class="basic_btn sbtn"
        @click="submit"
      >
        {{ $t('invest.next') }}
      </button>
    </form>

    <div
      v-if="data.channel != 5"
      class="tip"
    >
      {{ $t('invest.tip') }}
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import {
  CountDown,
  Checkbox,
  RadioGroup,
  Icon,
  Radio
} from 'vant';
import Fetch from '../../utils/fetch';

Vue.use(RadioGroup);
Vue.use(Radio);
Vue.use(CountDown).use(Checkbox).use(Icon);

export default {
  name: "Invest",
  data() {
    return {
      time: 0,
      eye: 1,
      balance: 0.00,
      data: {
        choose: '',
        channel: '',
        money: '',
        id: '',
        reason: ''
      },
      payment: [],
      config: {},
      actualAmount: '',
    };
  },
  computed: {
    paymentList() {
      return this.config && this.config.payment ? this.config.payment : [];
    }
  },
  created() {
    this.$parent.footer('user', false);
  },
  mounted() {
    this.start();
    var num = this.$router.history.current.params.code;
    if (num && num > 0) {
      this.data.money = num;
    }
  },
  methods: {
    start() {
      Fetch('/user/recharge', {
        ...this.data
      }).then((r) => {
        this.balance = r.data.money;
        this.config = r.data;
        this.config.min_recharge = parseInt(this.config.min_recharge);
        if (r.data.payment && r.data.payment[0]) {
          this.choose_type(1, r.data.payment[0]);
        }
      });
    },
    checkLimit() {
      const key = 'invest_button';
      const ttl = 60;
      let now = Date.parse(new Date()) / 1000;
      let val = localStorage.getItem(key);
      if (!val) {
        val = JSON.stringify({
          'ttl': now + ttl
        });
        localStorage.setItem(key, val);
        return true;
      } else {
        val = JSON.parse(val);
        if (val['ttl'] > now) {
          return false;
        } else {
          val = JSON.stringify({
            'ttl': now + ttl
          });
          localStorage.setItem(key, val);
          return true;
        }
      }
    },
    choose_type(k, payment) {
      this.data.choose = k;
      this.data.channel = payment.type;
      this.data.id = payment.id;
      this.payment = payment;
      this.changeAmount();
    },
    submit() {
      if (!this.data.money || this.data.money < this.config.min_recharge) {
        this.$toast(this.$t('invest.rechargeAmountLow') + " " + this.utils_moneyMark() + this.config
          .min_recharge + this.$t('invest.rechargeAmountLow1'));
        return false;
      }
      if (!this.data.channel) {
        this.$toast(this.$t('invest.paymentMethodEmpty'));
        return false;
      }

      if (this.data.channel == 4) {
        this.$router.replace({
          path: '/invest/bank',
          query: {
            money: this.data.money,
            id: this.data.id
          }
        });
        return;
      } else if (this.data.channel == 2) {
        this.$router.replace({
          path: '/invest/alipay',
          query: {
            money: this.data.money,
            type: this.data.channel,
            id: this.data.id
          }
        });
        return;
      } else if (this.data.channel == 3) {
        this.$router.replace({
          path: '/invest/wx',
          query: {
            money: this.data.money,
            type: this.data.channel,
            id: this.data.id
          }
        });
        return;
      } else if (this.data.channel == 1) {
        this.$router.push("/kefu");
        return;
      } else {
        Fetch('/user/recharge_type', {
          money: this.data.money,
          id: this.data.id
        }).then((r) => {
          this.$router.push("/kefu");
          if (r.data.payment.payurl != '') {
            // Reserved for existing third-party payment redirect behavior.
          }
        });
      }
    },
    changeAmount() {
      var num = 0;
      if (!this.payment.type || !this.data.money) {
        this.actualAmount = '';
        return;
      }
      if (this.payment.type == 1) {
        if (this.payment.rate > 10000) {
          num = 8;
        } else if (this.payment.rate > 1000) {
          num = 6;
        } else if (this.payment.rate > 10) {
          num = 4;
        }
        this.actualAmount = this.utils_moneyMark() + ' ' + (this.data.money / this.payment.rate).toFixed(num);
      } else {
        this.actualAmount = this.payment.mark + ' ' + (this.data.money / this.payment.rate).toFixed(num);
      }
    }
  }
};
</script>

<style lang="less" scoped>
.invest-page {
  min-height: 100vh;
  padding-bottom: 96px;
  background: #111;
  color: #f6f6f6;
  box-sizing: border-box;
}

button {
  border: 0;
  font: inherit;
  cursor: pointer;
}

.page-top {
  background: #111;
  color: #f6f6f6;
  border-bottom: 1px solid #242424;
  box-sizing: border-box;

  .back_left {
    filter: invert(1);
    opacity: 0.88;
  }

  .big_tit {
    max-width: 72%;
    color: #f6f6f6;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    word-break: normal;
  }
}

.top_right {
  top: 9px;
  right: 15px;
  width: 32px;
  height: 32px;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  color: #8ea0ff;
  background: rgba(101, 123, 233, 0.18);
}

.balance-card,
.amount-card,
.payment-card,
.tip {
  margin: 14px 16px 0;
  overflow: hidden;
  border-radius: 12px;
  border: 1px solid #303030;
  background: #222;
  box-shadow: 0 12px 22px rgba(0, 0, 0, 0.22);
  box-sizing: border-box;
}

.balance-card {
  padding: 20px 18px;
  text-align: center;
  background: #1f1f1f;
}

.balance-card p,
.balance-card span {
  margin: 0;
  color: #c6cad2;
  font-size: 14px;
  line-height: 20px;
}

.balance-card strong {
  display: block;
  margin: 10px 0 8px;
  overflow: hidden;
  color: #8ea0ff;
  font-size: 24px;
  font-weight: 700;
  line-height: 30px;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-break: normal;
}

.form {
  margin: 0;
}

.amount-card {
  padding: 16px;
}

.card-title,
.tit {
  margin: 0;
  color: #f6f6f6;
  font-size: 16px;
  font-weight: 700;
  line-height: 22px;
}

.amount-field {
  min-height: 48px;
  margin-top: 14px;
  padding: 0 12px;
  display: flex;
  align-items: center;
  border-radius: 10px;
  background: #1f1f1f;
  box-sizing: border-box;
}

.amount-field input {
  min-width: 0;
  height: 48px;
  flex: 1;
  border: 0;
  outline: none;
  background: transparent;
  color: #f6f6f6;
  font-size: 16px;
  line-height: 48px;
}

.amount-field input::placeholder {
  color: #9aa1aa;
}

.amount-mark {
  flex: 0 0 auto;
  margin-left: 10px;
  color: #8ea0ff;
  font-size: 14px;
  font-weight: 700;
}

.amount-preview {
  margin: 12px 0 0;
  overflow: hidden;
  color: #9aa1aa;
  font-size: 12px;
  line-height: 18px;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-break: normal;
}

.payment-card {
  padding: 0 16px;
}

.tit {
  height: 54px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #303030;
}

.item {
  min-height: 58px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #303030;
}

.item:last-child {
  border-bottom: 0;
}

.item.active .re_name {
  color: #8ea0ff;
}

.check {
  width: 16px;
  height: 16px;
  flex: 0 0 16px;
  margin-left: 2px;
  border-radius: 50%;
  border: 1px solid #343434;
  background: #151515;
  box-sizing: border-box;
}

.check.checked {
  border: 4px solid #8ea0ff;
  background: #657be9;
}

.re_icon {
  width: 36px;
  height: 36px;
  flex: 0 0 36px;
  margin-left: 12px;
  overflow: hidden;
  border-radius: 8px;
  background: #1f1f1f;
}

.re_icon img {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: contain;
}

.re_name {
  min-width: 0;
  margin-left: 10px;
  overflow: hidden;
  color: #f6f6f6;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-break: normal;
}

.basic_btn {
  width: calc(100% - 32px);
  height: 44px;
  margin: 24px 16px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  border: 1px solid #343434;
  background: linear-gradient(100deg, #657be9 0%, #8c52bd 100%) !important;
  color: #8ea0ff;
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  box-sizing: border-box;
}

.tip {
  padding: 14px 16px;
  color: #9aa1aa;
  font-size: 12px;
  line-height: 20px;
}


.basic_btn,
.history_coupon,
.wallet-btn.is-primary,
.allbtn {
  border: 0;
  background: linear-gradient(100deg, #657be9 0%, #8c52bd 100%) !important;
  color: #fff;
}


.page-top {
  background: #101010;
}

@media screen and (max-width: 374px) {
  .balance-card,
  .amount-card,
  .payment-card,
  .tip {
    margin-right: 12px;
    margin-left: 12px;
  }

  .basic_btn {
    width: calc(100% - 24px);
    margin-right: 12px;
    margin-left: 12px;
  }
}
</style>
